import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

// ==========================================
// 🎨 ÍCONES SVG MODERNOS
// ==========================================
const Icons = {
  Robot: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/></svg>,
  Save: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>,
  Play: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>,
  Plus: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
  X: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  Shield: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>,
  Send: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>,
  Tag: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>,
  Trophy: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"></path></svg>,
  Store: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>,
  Chart: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>,
  Receipt: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
  Refresh: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10"></path><path d="M20.49 15a9 9 0 0 1-14.13 3.36L1 14"></path></svg>
};

const defaultProfessionalTemplate = `[SISTEMA VIZUM] - Nova Venda Registrada

OS: #{os}
Loja: {loja}
Vendedor: {vendedor}

Cliente: {cliente}
Lente: {lente}

Valor: {valor}
Pgto: {pagamento}

Data: {data} às {hora}`;

export default function RoboConfig({ showToast }) {
  const [activeTab, setActiveTab] = useState('config');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [sendingTest, setSendingTest] = useState(false);
  const [loadingDashboard, setLoadingDashboard] = useState(false);
  const [novoNumero, setNovoNumero] = useState('');
  const [periodoResumo, setPeriodoResumo] = useState('diario');
  const [roboStatus, setRoboStatus] = useState({ queueLength: 0 });

  const [dashData, setDashData] = useState({
    placares: [],
    lojas: [],
    ultimasVendas: [],
    periodo: 'diario'
  });

  const [config, setConfig] = useState({
    numerosAdmin: [],
    template: defaultProfessionalTemplate,
    ativo: true
  });

  const variables = [
    { label: 'OS', val: '{os}' },
    { label: 'Cliente', val: '{cliente}' },
    { label: 'Lente', val: '{lente}' },
    { label: 'Valor', val: '{valor}' },
    { label: 'Pgto', val: '{pagamento}' },
    { label: 'Vendedor', val: '{vendedor}' },
    { label: 'Loja', val: '{loja}' },
    { label: 'Data', val: '{data}' },
    { label: 'Hora', val: '{hora}' }
  ];

  const periodoLabel = periodoResumo === 'mensal' ? 'Mensal' : 'Diário';
  const tituloPeriodo = periodoResumo === 'mensal' ? 'Mês' : 'Hoje';

  // ==========================================
  // 📥 DASHBOARD
  // ==========================================
  const loadDashboard = useCallback(async (periodoAtual = 'diario', silent = false) => {
    if (!silent) setLoadingDashboard(true);

    try {
      const resDash = await api.get(`/api/dashboard-resumos?periodo=${periodoAtual}`);
      if (resDash.data) {
        setDashData({
          placares: resDash.data.placares || [],
          lojas: resDash.data.lojas || [],
          ultimasVendas: resDash.data.ultimasVendas || [],
          periodo: resDash.data.periodo || periodoAtual
        });
      }
    } catch (error) {
      showToast('error', 'Falha ao carregar o dashboard.');
    } finally {
      if (!silent) setLoadingDashboard(false);
    }
  }, [showToast]);

  // ==========================================
  // 📥 CARGA INICIAL
  // ==========================================
  useEffect(() => {
    async function loadData() {
      try {
        const resConfig = await api.get('/api/config-vendas');
        const dataConfig = resConfig.data;

        const rawNumbers = Array.isArray(dataConfig.numerosAdmin)
          ? dataConfig.numerosAdmin
          : (dataConfig.numeroAdmin ? dataConfig.numeroAdmin.split(',') : []);

        setConfig({
          ativo: dataConfig.ativo ?? true,
          template: dataConfig.template || defaultProfessionalTemplate,
          numerosAdmin: rawNumbers.filter(Boolean).map(n => String(n).trim())
        });

        await loadDashboard(periodoResumo, true);
      } catch (error) {
        showToast('error', 'Falha ao carregar dados do servidor.');
      } finally {
        setTimeout(() => setLoading(false), 1200);
      }
    }

    loadData();
  }, [showToast, loadDashboard, periodoResumo]);

  // ==========================================
  // 🔄 TROCA DE PERÍODO
  // ==========================================
  useEffect(() => {
    if (!loading) {
      loadDashboard(periodoResumo);
    }
  }, [periodoResumo, loading, loadDashboard]);

  // ==========================================
  // 📡 STATUS DA FILA
  // ==========================================
  const fetchStatus = useCallback(async () => {
    try {
      const { data } = await api.get('/api/cron-status');
      setRoboStatus({ queueLength: data.queueLength || 0 });
    } catch (err) {}
  }, []);

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 5000);
    return () => clearInterval(interval);
  }, [fetchStatus]);

  // ==========================================
  // 💾 AÇÕES
  // ==========================================
  const saveToServer = async (updatedConfig) => {
    try {
      await api.post('/api/config-vendas', {
        ...updatedConfig,
        numeroAdmin: updatedConfig.numerosAdmin.join(',')
      });
      return true;
    } catch (error) {
      showToast('error', 'Erro ao salvar configurações.');
      return false;
    }
  };

  const handleGlobalSave = async () => {
    setSaving(true);
    if (await saveToServer(config)) {
      showToast('success', 'Configurações atualizadas.');
    }
    setSaving(false);
  };

  const handleAddNumero = async () => {
    const cleanNum = novoNumero.replace(/\D/g, '');

    if (cleanNum.length < 10) {
      return showToast('info', 'Insira um número válido com DDD.');
    }

    if (config.numerosAdmin.includes(cleanNum)) {
      return showToast('info', 'Número já registrado.');
    }

    const newConfig = {
      ...config,
      numerosAdmin: [...config.numerosAdmin, cleanNum]
    };

    setConfig(newConfig);
    setNovoNumero('');

    if (await saveToServer(newConfig)) {
      showToast('success', 'Administrador adicionado.');
    }
  };

  const handleRemoveNumero = async (num) => {
    const newConfig = {
      ...config,
      numerosAdmin: config.numerosAdmin.filter(n => n !== num)
    };

    setConfig(newConfig);

    if (await saveToServer(newConfig)) {
      showToast('success', 'Administrador removido.');
    }
  };

  const handleForceCron = async () => {
    try {
      const res = await api.post('/api/cron-force');
      showToast('success', res.data?.message || 'Motor de vendas acionado.');
      fetchStatus();
    } catch (error) {
      showToast('info', error.response?.data?.message || 'Nenhuma ação necessária no momento.');
    }
  };

  const handleSendLastSale = async () => {
    setSendingTest(true);
    try {
      const res = await api.post('/api/send-last-sale');
      if (res.data?.success) {
        showToast('success', 'Teste adicionado à fila de envio.');
        fetchStatus();
      } else {
        showToast('error', res.data?.message || 'Falha ao processar teste.');
      }
    } catch (error) {
      showToast('error', 'Erro de comunicação com o servidor.');
    } finally {
      setSendingTest(false);
    }
  };

  const handleDispararResumo = async (tipo) => {
    showToast('info', `Enviando resumo ${periodoLabel.toLowerCase()} para o WhatsApp...`);
    try {
      const res = await api.post('/api/send-summary', {
        type: tipo,
        periodo: periodoResumo
      });

      if (res.data.success) {
        showToast('success', 'Resumo enviado com sucesso.');
        fetchStatus();
      } else {
        showToast('error', res.data.message || 'Falha ao enviar resumo.');
      }
    } catch (error) {
      showToast('error', 'Erro ao enviar o resumo.');
    }
  };

  const handleRefreshDashboard = async () => {
    await loadDashboard(periodoResumo);
    showToast('success', `Dashboard ${periodoLabel.toLowerCase()} atualizado.`);
  };

  if (loading) {
    return (
      <div className="robo-loader-container">
        <div className="spinner-modern"></div>
        <h3 className="loading-title">Inicializando Vizum AI</h3>
        <p className="loading-subtitle">Sincronizando placares e inteligência...</p>
      </div>
    );
  }

  return (
    <div className="admin-wrapper">
      {/* HEADER */}
      <header className="premium-header">
        <div className="header-brand">
          <div className="icon-cube"><Icons.Robot /></div>
          <div>
            <h1>Motor Vizum AI</h1>
            <p>Automação WhatsApp & BI Vendas</p>
          </div>
        </div>

        <div className="header-actions">
          {activeTab === 'config' && (
            <div className="action-buttons-group">
              <button className="btn-secondary" onClick={handleSendLastSale} disabled={sendingTest}>
                <Icons.Send /> {sendingTest ? 'Processando...' : 'Testar OS'}
              </button>

              <button className="btn-outline" onClick={handleForceCron}>
                <Icons.Play /> Sincronizar
              </button>
            </div>
          )}

          {activeTab === 'resumos' && (
            <div className="action-buttons-group">
              <button className="btn-outline" onClick={handleRefreshDashboard} disabled={loadingDashboard}>
                <Icons.Refresh /> {loadingDashboard ? 'Atualizando...' : 'Atualizar'}
              </button>
            </div>
          )}

          <div className="status-badge">
            <span className="status-label">{config.ativo ? 'ATIVO' : 'PAUSADO'}</span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={config.ativo}
                onChange={e => setConfig({ ...config, ativo: e.target.checked })}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </header>

      {/* ABAS */}
      <div className="custom-tabs">
        <button className={activeTab === 'config' ? 'active' : ''} onClick={() => setActiveTab('config')}>
          <Icons.Tag /> Alertas
        </button>

        <button className={activeTab === 'resumos' ? 'active' : ''} onClick={() => setActiveTab('resumos')}>
          <Icons.Chart /> Dashboards
        </button>
      </div>

      {roboStatus.queueLength > 0 && (
        <div className="alert-banner">
          <Icons.Shield />
          <span><b>Anti-ban ativo:</b> {roboStatus.queueLength} notificações na fila.</span>
        </div>
      )}

      {/* ABA CONFIG */}
      {activeTab === 'config' && (
        <main className="dashboard-layout">
          <section className="config-section">
            <div className="premium-card">
              <div className="card-title">
                <h3>Gestão de Recebedores</h3>
                <p>Admins que receberão os alertas no WhatsApp.</p>
              </div>

              <div className="input-with-button">
                <input
                  type="text"
                  placeholder="Ex: 92988887777"
                  value={novoNumero}
                  onChange={e => setNovoNumero(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleAddNumero()}
                />
                <button onClick={handleAddNumero}><Icons.Plus /> Add</button>
              </div>

              <div className="admin-list">
                {config.numerosAdmin.map(num => (
                  <div key={num} className="admin-chip">
                    <span className="chip-text">
                      {num.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')}
                    </span>
                    <button className="chip-close" onClick={() => handleRemoveNumero(num)}>
                      <Icons.X />
                    </button>
                  </div>
                ))}
                {config.numerosAdmin.length === 0 && (
                  <span className="empty-text">Nenhum administrador.</span>
                )}
              </div>
            </div>

            <div className="premium-card">
              <div className="card-title">
                <h3>Template de Notificação</h3>
                <p>Estrutura da mensagem para cada venda.</p>
              </div>

              <div className="variables-grid">
                {variables.map(v => (
                  <button
                    key={v.val}
                    className="var-btn"
                    onClick={() => setConfig(prev => ({ ...prev, template: prev.template + v.val }))}
                  >
                    {v.label}
                  </button>
                ))}
              </div>

              <textarea
                className="code-textarea"
                rows="8"
                value={config.template}
                onChange={e => setConfig({ ...config, template: e.target.value })}
                placeholder="Digite o padrão da mensagem aqui..."
              />

              <button className="btn-primary" onClick={handleGlobalSave} disabled={saving}>
                {saving ? 'Gravando...' : <><Icons.Save /> Salvar</>}
              </button>
            </div>
          </section>

          <section className="preview-section">
            <div className="smartphone-mockup">
              <div className="dynamic-island"></div>
              <div className="mockup-screen">
                <div className="mockup-header">
                  <div className="mockup-avatar">V</div>
                  <div className="mockup-contact">
                    <h4>Vizum</h4>
                    <span>Bot Comercial</span>
                  </div>
                </div>

                <div className="mockup-chat-bg">
                  <div className="mockup-bubble">
                    {config.template || 'O modelo aparecerá aqui...'}
                    <span className="mockup-time">Agora</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      )}

      {/* ABA RESUMOS */}
      {activeTab === 'resumos' && (
        <main className="resumos-layout">
          <div className="premium-card">
            <div className="toolbar-row">
              <div className="card-title">
                <h3>Painel de Resumos</h3>
                <p>Controle do dashboard e do envio por período.</p>
              </div>

              <div className="period-toolbar">
                <span className="period-label">Período</span>

                <div className="period-switch">
                  <button
                    className={periodoResumo === 'diario' ? 'active' : ''}
                    onClick={() => setPeriodoResumo('diario')}
                  >
                    Diário
                  </button>
                  <button
                    className={periodoResumo === 'mensal' ? 'active' : ''}
                    onClick={() => setPeriodoResumo('mensal')}
                  >
                    Mensal
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="premium-card">
            <div className="card-header-flex">
              <div className="card-title">
                <h3><Icons.Trophy /> Placar de Vendedores ({tituloPeriodo})</h3>
                <p>Visualização {periodoLabel.toLowerCase()} do ranking.</p>
              </div>

              <button className="btn-outline-primary" onClick={() => handleDispararResumo('placar')}>
                <Icons.Send /> Enviar Placar
              </button>
            </div>

            {loadingDashboard ? (
              <div className="empty-state">Atualizando dados...</div>
            ) : (
              <div className="leaderboard-list">
                {dashData.placares.length === 0 && (
                  <div className="empty-state">Nenhuma venda no período.</div>
                )}

                {dashData.placares.map((vendedor, index) => (
                  <div key={vendedor.id} className={`rank-item rank-${index + 1}`}>
                    <div className="rank-position">{index + 1}º</div>
                    <div className="rank-info">
                      <h4>{vendedor.vendedor}</h4>
                      <span>{vendedor.vendas} vendas no período</span>
                    </div>
                    <div className="rank-value">{vendedor.valor}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="resumos-grid-2">
            <div className="premium-card">
              <div className="card-header-flex">
                <div className="card-title">
                  <h3><Icons.Store /> Resumo Lojas ({tituloPeriodo})</h3>
                  <p>Faturamento e volume por loja.</p>
                </div>

                <button className="btn-icon" onClick={() => handleDispararResumo('lojas')} title="Enviar Resumo">
                  <Icons.Send />
                </button>
              </div>

              {loadingDashboard ? (
                <div className="empty-state">Atualizando dados...</div>
              ) : (
                <div className="store-grid">
                  {dashData.lojas.length === 0 && <div className="empty-state">Sem dados no período.</div>}

                  {dashData.lojas.map(loja => (
                    <div key={loja.id} className="store-card">
                      <h5>{loja.nome}</h5>
                      <div className="store-stats">
                        <span>{loja.vendas} vendas</span>
                        <strong>{loja.valor}</strong>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="premium-card">
              <div className="card-header-flex">
                <div className="card-title">
                  <h3>
                    <Icons.Receipt /> Extrato ({periodoResumo === 'mensal' ? 'Top do período' : 'Top 10'})
                  </h3>
                  <p>Últimas vendas retornadas pelo backend.</p>
                </div>

                <button className="btn-icon" onClick={() => handleDispararResumo('extrato')} title="Enviar Extrato">
                  <Icons.Send />
                </button>
              </div>

              {loadingDashboard ? (
                <div className="empty-state">Atualizando dados...</div>
              ) : (
                <div className="sales-table-wrapper">
                  <table className="sales-table">
                    <thead>
                      <tr>
                        <th>OS</th>
                        <th>Loja</th>
                        <th>Vendedor</th>
                        <th>Valor</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashData.ultimasVendas.length === 0 && (
                        <tr>
                          <td colSpan="5" className="text-center">Sem histórico no período.</td>
                        </tr>
                      )}

                      {dashData.ultimasVendas.map((venda, index) => (
                        <tr key={`${venda.os}-${index}`}>
                          <td>#{venda.os}</td>
                          <td>{venda.loja}</td>
                          <td>{venda.vendedor}</td>
                          <td><strong>{venda.valor}</strong></td>
                          <td>{venda.data || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </main>
      )}

      <style>{`
        :root {
          --bg-color: #f1f5f9;
          --surface: #ffffff;
          --text-main: #0f172a;
          --text-muted: #64748b;
          --primary: #2563eb;
          --primary-hover: #1d4ed8;
          --border-color: #e2e8f0;
          --success: #10b981;
          --danger: #ef4444;
          --gold: #fbbf24;
          --silver: #94a3b8;
          --bronze: #b45309;
          --radius-sm: 6px;
          --radius-md: 8px;
          --radius-lg: 12px;
          --font-xs: 11px;
          --font-sm: 12px;
          --font-md: 13px;
          --font-lg: 15px;
          --font-xl: 18px;
        }

        * { box-sizing: border-box; }

        .admin-wrapper {
          max-width: 1000px;
          margin: 0 auto;
          padding: 20px 15px;
          font-family: 'Inter', system-ui, sans-serif;
          color: var(--text-main);
          background: var(--bg-color);
          min-height: 100vh;
        }

        .robo-loader-container {
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: var(--bg-color);
        }

        .spinner-modern {
          width: 30px;
          height: 30px;
          border: 3px solid var(--border-color);
          border-top-color: var(--primary);
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 15px;
        }

        .loading-title {
          font-size: var(--font-lg);
          margin: 0 0 4px 0;
          color: var(--text-main);
        }

        .loading-subtitle {
          font-size: var(--font-sm);
          color: var(--text-muted);
          margin: 0;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .premium-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 20px;
        }

        .header-brand {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .icon-cube {
          background: var(--text-main);
          color: white;
          width: 38px;
          height: 38px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(15, 23, 42, 0.15);
        }

        .header-brand h1 {
          margin: 0;
          font-size: var(--font-xl);
          font-weight: 700;
          letter-spacing: -0.5px;
        }

        .header-brand p {
          margin: 2px 0 0 0;
          font-size: var(--font-xs);
          color: var(--text-muted);
        }

        .header-actions {
          display: flex;
          gap: 10px;
          align-items: center;
          flex-wrap: wrap;
        }

        .action-buttons-group {
          display: flex;
          gap: 8px;
        }

        .custom-tabs {
          display: flex;
          gap: 4px;
          margin-bottom: 20px;
          border-bottom: 1px solid var(--border-color);
          overflow-x: auto;
          white-space: nowrap;
          padding-bottom: 2px;
        }

        .custom-tabs button {
          background: transparent;
          border: none;
          padding: 10px 16px;
          font-size: var(--font-md);
          font-weight: 600;
          color: var(--text-muted);
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          border-bottom: 2px solid transparent;
          transition: 0.2s;
        }

        .custom-tabs button:hover { color: var(--primary); }
        .custom-tabs button.active {
          color: var(--primary);
          border-bottom-color: var(--primary);
        }

        .custom-tabs::-webkit-scrollbar { height: 2px; }
        .custom-tabs::-webkit-scrollbar-thumb { background: #cbd5e1; }

        .btn-primary {
          width: 100%;
          background: var(--primary);
          color: white;
          border: none;
          padding: 10px;
          border-radius: var(--radius-md);
          font-weight: 600;
          font-size: var(--font-md);
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 6px;
          transition: 0.2s;
          margin-top: 15px;
        }

        .btn-primary:hover:not(:disabled) { background: var(--primary-hover); }

        .btn-secondary,
        .btn-outline,
        .btn-outline-primary {
          padding: 8px 12px;
          border-radius: var(--radius-sm);
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 600;
          font-size: var(--font-sm);
          transition: 0.2s;
        }

        .btn-secondary {
          background: white;
          color: var(--text-main);
          border: 1px solid var(--border-color);
        }

        .btn-secondary:hover:not(:disabled) {
          background: #f8fafc;
          border-color: #cbd5e1;
        }

        .btn-outline {
          background: transparent;
          color: var(--text-muted);
          border: 1px dashed #cbd5e1;
        }

        .btn-outline:hover {
          background: white;
          color: var(--text-main);
          border-style: solid;
        }

        .btn-outline-primary {
          background: #eff6ff;
          color: var(--primary);
          border: 1px solid #bfdbfe;
        }

        .btn-outline-primary:hover {
          background: var(--primary);
          color: white;
          border-color: var(--primary);
        }

        .btn-icon {
          background: #f8fafc;
          color: var(--text-muted);
          border: 1px solid var(--border-color);
          width: 32px;
          height: 32px;
          border-radius: var(--radius-sm);
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: 0.2s;
        }

        .btn-icon:hover {
          background: var(--primary);
          color: white;
          border-color: var(--primary);
        }

        .status-badge {
          background: white;
          border: 1px solid var(--border-color);
          padding: 4px 10px;
          border-radius: var(--radius-sm);
          display: flex;
          align-items: center;
          gap: 8px;
          height: 34px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        }

        .status-label {
          font-size: var(--font-xs);
          font-weight: 700;
          color: var(--text-muted);
        }

        .toggle-switch {
          position: relative;
          width: 32px;
          height: 18px;
        }

        .toggle-switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .toggle-slider {
          position: absolute;
          cursor: pointer;
          top: 0; left: 0; right: 0; bottom: 0;
          background: #e2e8f0;
          transition: .3s;
          border-radius: 20px;
        }

        .toggle-slider:before {
          position: absolute;
          content: "";
          height: 12px;
          width: 12px;
          left: 3px;
          bottom: 3px;
          background: white;
          transition: .3s;
          border-radius: 50%;
          box-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }

        input:checked + .toggle-slider { background: var(--success); }
        input:checked + .toggle-slider:before { transform: translateX(14px); }

        .alert-banner {
          background: #eff6ff;
          border: 1px solid #bfdbfe;
          border-left: 3px solid var(--primary);
          padding: 10px 14px;
          border-radius: var(--radius-md);
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: var(--font-sm);
          color: #1e3a8a;
        }

        .dashboard-layout {
          display: grid;
          grid-template-columns: 1fr 280px;
          gap: 20px;
        }

        .resumos-layout {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .resumos-grid-2 {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 16px;
        }

        .premium-card {
          background: var(--surface);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-lg);
          padding: 16px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.02);
          margin-bottom: 16px;
        }

        .card-header-flex {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 12px;
          gap: 10px;
        }

        .toolbar-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .period-toolbar {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .period-label {
          font-size: var(--font-xs);
          font-weight: 700;
          color: var(--text-muted);
          text-transform: uppercase;
          letter-spacing: .08em;
        }

        .period-switch {
          display: flex;
          gap: 4px;
          background: #f8fafc;
          border: 1px solid var(--border-color);
          border-radius: 10px;
          padding: 4px;
        }

        .period-switch button {
          border: none;
          background: transparent;
          color: var(--text-muted);
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          font-size: var(--font-sm);
          font-weight: 700;
          transition: 0.2s;
        }

        .period-switch button.active {
          background: white;
          color: var(--text-main);
          box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        }

        .card-title h3 {
          margin: 0 0 2px 0;
          font-size: var(--font-lg);
          color: var(--text-main);
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .card-title p {
          margin: 0;
          font-size: var(--font-xs);
          color: var(--text-muted);
        }

        .empty-state {
          padding: 15px;
          text-align: center;
          color: var(--text-muted);
          font-size: var(--font-sm);
          background: #f8fafc;
          border-radius: var(--radius-md);
          border: 1px dashed var(--border-color);
        }

        .text-center {
          text-align: center !important;
          padding: 16px !important;
        }

        .input-with-button {
          display: flex;
          gap: 6px;
          margin-bottom: 16px;
        }

        .input-with-button input {
          flex: 1;
          padding: 8px 12px;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          font-size: var(--font-sm);
          outline: none;
          transition: 0.2s;
          background: #f8fafc;
        }

        .input-with-button input:focus {
          border-color: var(--primary);
          background: white;
        }

        .input-with-button button {
          background: var(--text-main);
          color: white;
          border: none;
          padding: 0 12px;
          border-radius: var(--radius-sm);
          cursor: pointer;
          font-weight: 600;
          font-size: var(--font-sm);
          display: flex;
          align-items: center;
          gap: 4px;
          transition: 0.2s;
        }

        .input-with-button button:hover { background: #334155; }

        .admin-list {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .admin-chip {
          background: #f1f5f9;
          border: 1px solid var(--border-color);
          padding: 4px 10px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .chip-text {
          font-size: var(--font-xs);
          font-weight: 600;
          color: var(--text-main);
        }

        .chip-close {
          border: none;
          background: #e2e8f0;
          color: var(--text-muted);
          width: 16px;
          height: 16px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 0;
          transition: 0.2s;
        }

        .chip-close:hover {
          background: var(--danger);
          color: white;
        }

        .variables-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
          gap: 6px;
          margin-bottom: 16px;
        }

        .var-btn {
          background: #f8fafc;
          color: var(--text-main);
          border: 1px dashed #cbd5e1;
          padding: 6px;
          border-radius: var(--radius-sm);
          font-size: var(--font-xs);
          font-weight: 600;
          cursor: pointer;
          transition: 0.2s;
          text-align: center;
        }

        .var-btn:hover {
          border-style: solid;
          border-color: var(--primary);
          color: var(--primary);
          background: #eff6ff;
        }

        .code-textarea {
          width: 100%;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-md);
          padding: 12px;
          font-family: monospace;
          font-size: var(--font-sm);
          line-height: 1.4;
          resize: vertical;
          outline: none;
          background: #f8fafc;
          color: #334155;
        }

        .code-textarea:focus {
          border-color: var(--primary);
          background: white;
        }

        .leaderboard-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .rank-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 12px;
          border-radius: var(--radius-md);
          background: #f8fafc;
          border: 1px solid var(--border-color);
          transition: 0.2s;
        }

        .rank-item:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }

        .rank-position {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          font-size: var(--font-xs);
          color: white;
          background: var(--text-muted);
        }

        .rank-1 .rank-position {
          background: var(--gold);
          box-shadow: 0 0 8px rgba(251, 191, 36, 0.4);
        }

        .rank-2 .rank-position { background: var(--silver); }
        .rank-3 .rank-position { background: var(--bronze); }

        .rank-info { flex: 1; }

        .rank-info h4 {
          margin: 0;
          font-size: var(--font-sm);
          color: var(--text-main);
        }

        .rank-info span {
          font-size: var(--font-xs);
          color: var(--text-muted);
        }

        .rank-value {
          font-weight: 700;
          font-size: var(--font-md);
          color: var(--success);
        }

        .store-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
          gap: 10px;
        }

        .store-card {
          background: #f8fafc;
          border: 1px solid var(--border-color);
          padding: 12px;
          border-radius: var(--radius-md);
        }

        .store-card h5 {
          margin: 0 0 8px 0;
          font-size: var(--font-sm);
          color: var(--text-main);
        }

        .store-stats {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .store-stats span {
          font-size: var(--font-xs);
          color: var(--text-muted);
        }

        .store-stats strong {
          font-size: var(--font-sm);
          color: var(--text-main);
        }

        .sales-table-wrapper {
          overflow-x: auto;
          margin: 0 -8px;
          padding: 0 8px;
        }

        .sales-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
          font-size: var(--font-sm);
          white-space: nowrap;
        }

        .sales-table th {
          padding: 8px;
          color: var(--text-muted);
          font-weight: 600;
          border-bottom: 1px solid var(--border-color);
        }

        .sales-table td {
          padding: 8px;
          border-bottom: 1px solid #f1f5f9;
          color: var(--text-main);
        }

        .sales-table tr:last-child td { border-bottom: none; }

        .smartphone-mockup {
          background: #ffffff;
          border-radius: 30px;
          border: 8px solid #cbd5e1;
          height: 450px;
          box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
          position: sticky;
          top: 20px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .dynamic-island {
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 22px;
          background: #0f172a;
          border-radius: 15px;
          z-index: 10;
        }

        .mockup-screen {
          flex: 1;
          display: flex;
          flex-direction: column;
          background: #f4f4f5;
          padding-top: 35px;
        }

        .mockup-header {
          background: rgba(255,255,255,0.9);
          padding: 10px 15px;
          display: flex;
          align-items: center;
          gap: 10px;
          border-bottom: 1px solid #e2e8f0;
        }

        .mockup-avatar {
          width: 32px;
          height: 32px;
          background: linear-gradient(135deg, var(--primary), #60a5fa);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: var(--font-sm);
          font-weight: bold;
        }

        .mockup-contact h4 {
          margin: 0;
          font-size: var(--font-sm);
          color: #18181b;
          font-weight: 600;
        }

        .mockup-contact span {
          font-size: var(--font-xs);
          color: #71717a;
        }

        .mockup-chat-bg {
          flex: 1;
          background-color: #efeae2;
          padding: 15px;
          overflow-y: auto;
        }

        .mockup-bubble {
          background: #ffffff;
          padding: 10px 12px 20px 12px;
          border-radius: 0 10px 10px 10px;
          font-size: var(--font-xs);
          line-height: 1.5;
          white-space: pre-wrap;
          color: #27272a;
          box-shadow: 0 1px 2px rgba(0,0,0,0.1);
          position: relative;
          max-width: 95%;
          margin-top: 8px;
          font-family: sans-serif;
        }

        .mockup-time {
          position: absolute;
          bottom: 4px;
          right: 8px;
          font-size: 9px;
          color: #a1a1aa;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .dashboard-layout,
          .resumos-grid-2 {
            grid-template-columns: 1fr;
          }

          .preview-section {
            display: none;
          }

          .header-actions {
            width: 100%;
            justify-content: space-between;
          }

          .action-buttons-group {
            flex: 1;
            display: flex;
          }

          .action-buttons-group button {
            flex: 1;
            justify-content: center;
          }

          .card-header-flex,
          .toolbar-row {
            flex-direction: column;
            gap: 10px;
          }

          .btn-outline-primary,
          .btn-icon {
            width: 100%;
            justify-content: center;
          }

          .period-toolbar {
            width: 100%;
            justify-content: space-between;
          }

          .period-switch {
            width: 100%;
          }

          .period-switch button {
            flex: 1;
          }
        }
      `}</style>
    </div>
  );
}